import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function InovaconIcon() {
  return (
    <SvgIcon sx={{ height: 21, width: 100, mr: 2 }}>
      <svg
        width={86}
        height={19}
        viewBox="0 0 86 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          x="0"
          y="15"
          fill="#4876EE"
          fontFamily="Arial, Helvetica, sans-serif"
          fontSize="16"
          fontWeight="bold"
        >
          INOVACON
        </text>
      </svg>
    </SvgIcon>
  );
}
